import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Publication } from '../../opds2';
import { UtilMixin } from '../../UtilMixin';

@Component({ components: {} })
export default class SuggestionEntryMetadata extends Mixins(UtilMixin) {
  @Prop({ default: 400 }) public summaryMaxSize!: number;
  @Prop({ default: 40 }) public authorsMaxSize!: number;
  @Prop() public publication!: Publication;
  @Prop({ default: false }) public displayLicenses!: boolean;

  public get licensesString() {
    return this.publication.licenses
      .map((l) => this.$options!.filters!.license(l))
      .join(',');
  }
}
